import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./NewDashboard.module.css";
import HeroSection from "./Essentials/HeroSection/HeroSection";
import ExamSection from "./Essentials/ExamSection/ExamSection";
// import OurSuccess from "./Essentials/OurSuccess/OurSuccess";
// import StudentTestimonials from "./Essentials/StudentTestimonials/StudentTestimonials";
import OurCentres from "./Essentials/OurCentres/OurCentres";
import StudyMaterial from "./Essentials/StudyMaterial/StudyMaterial";
// import StudentStatistics from "./Essentials/StudentStatistics/StudentStatistics";
import SampleClasses from "./Essentials/SampleClasses/SampleClasses";
import DownloadAppSection from "./Essentials/DownloadAppSection/DownloadAppSection";
// import DashboardBanners from "../Dashboard/Essentials/DashboardBanners/DashboardBanners";
import { ApiHitPost } from "../../Services/ApiHit";
import Loader from "../Includes/Loader/Loader";
import TopSection from "./Essentials/TopSection/TopSection";
import { Helmet } from 'react-helmet';

const NewDashboard = ({ SelectedVertical, onVerticalSelect}) => {
    // const [SelectedVertical, setSelectedVertical] = useState(1);
    const [bannerInformation, setBannerInformation] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const navigate = useNavigate();
    
    const location = useLocation();
    const canonicalUrl = `${window.location.origin}${location.pathname}`;

    useEffect(() => {
        const fetchBannerData = async () => {
            setLoading(true);
            try {
                const response = await ApiHitPost("/Dashboard/get_dashboard_data", {
                    vertical_id: SelectedVertical ?? 1,
                });
                setBannerInformation(response.data.banners_information);
            } catch (error) {
                setError("Failed to load banner data");
            } finally {
                setLoading(false);
            }
        };

        fetchBannerData();
    }, [SelectedVertical]);

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <div className="text-red-500">Error: {error}</div>;
    }

    return (
        <>
            <Helmet>
                <title>Drishti Learning App - UPSC, Judiciary, SSC, CUET & More Exam Prep Resources</title>
                <meta name="description" content="Join India's leading competitive exam preparation platform. Enroll in online courses, attempt test series, or buy books for UPSC, SSC, CUET, Judiciary & more - all in one app." />
                <meta name="keywords" content="drishti learning app, upsc preparation, judiciary coaching, ssc online classes, cuet test series, government exam books, drishti ias online course, competitive exams app, drishti test series, buy drishti books" />
                <meta property="og:title" content="Join India's leading competitive exam preparation platform. Enroll in online courses, attempt test series, or buy books for UPSC, SSC, CUET, Judiciary & more - all in one app." />
                <meta property="og:description" content="drishti learning app, upsc preparation, judiciary coaching, ssc online classes, cuet test series, government exam books, drishti ias online course, competitive exams app, drishti test series, buy drishti books" />
                <link rel="canonical" href={canonicalUrl} />
            </Helmet>
            <section className={styles.MainSection}>
                {/* <DashboardBanners BannerInformation={bannerInformation} /> */}
                <TopSection SelectedVertical={SelectedVertical} onVerticalSelect={onVerticalSelect} />
                <HeroSection />
                <ExamSection />
                {/* <OurSuccess /> */}
                {/* <StudentTestimonials /> */}
                <OurCentres />
                <StudyMaterial />
                {/* <StudentStatistics /> */}
                <SampleClasses />
                <DownloadAppSection />
            </section>
        </>
    );
};

export default NewDashboard;
